angular.module('reposTableModule')

    .directive('sshKeysTable', ['GhDialog', 'SshKeysService', function (GhDialog, SshKeysService) {
        return {
            restrict: 'E',
            scope: {
                sshKeys: '='
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.sshKeys)) {
                    $scope.sshKeys = [];
                }

                $scope.$watchCollection('sshKeys', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.sshKeys = [];
                    }
                });

                $scope.formatDate = function (dateStr) {
                    if (!dateStr) return '—';
                    const d = new Date(dateStr);
                    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
                };

                $scope.truncateKey = function (key) {
                    if (!key) return '—';
                    return key.length > 40 ? key.substring(0, 40) + '…' : key;
                };

                $scope.showDeleteKeyPopup = function (key) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_repo-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">Deleting SSH Key!</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            Do you really want to delete this SSH key?
                                            You will not be able to restore it.
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteKey()"
                                            >
                                                Delete
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: { key },
                        controller: [
                            '$scope',
                            'key',
                            'SshKeysService',
                            function ($scope, key, SshKeysService) {
                                $scope.deleteKey = async function () {
                                    try {
                                        await SshKeysService.delete(key._id);

                                        if (!Array.isArray(tableScope.sshKeys)) {
                                            tableScope.sshKeys = [];
                                        }

                                        const index = tableScope.sshKeys.findIndex(function (k) {
                                            return k._id === key._id;
                                        });

                                        if (index !== -1) {
                                            tableScope.sshKeys.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('SSH key delete error:', error);
                                    }
                                };
                            }
                        ]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-5">
                            <div class="tab">#</div>
                        </div>

                        <div class="listing_table_column bottom_line w-25">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column bottom_line w-25">
                            <div class="tab">{{translate('Created')}}</div>
                        </div>

                        <div class="listing_table_column bottom_line w-35">
                            <div class="tab">{{translate('Public Key')}}</div>
                        </div>

                        <div class="listing_table_column bottom_line w-10"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row ssh-key-row"
                            ng-repeat="key in sshKeys track by key._id"
                        >
                            <div class="listing_table_column w-5">
                                <span class="number">{{$index + 1}}</span>
                            </div>

                            <div class="listing_table_column w-25">
                                <div class="name">{{key.name}}</div>
                            </div>

                            <div class="listing_table_column w-25">
                                <div class="name">{{formatDate(key.createdAt)}}</div>
                            </div>

                            <div class="listing_table_column w-35">
                                <div class="name key-preview">{{truncateKey(key.public_ssh_key)}}</div>
                            </div>

                            <div class="listing_table_column w-10">
                                <span
                                    ng-click="showDeleteKeyPopup(key); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!sshKeys.length" class="listing_table_nodata">
                            <p>{{translate('No SSH Keys')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }]);
